function initSolarCarousel() {
  const sectionContainer = document.querySelector('[id^="SolarSection-"]');
  if (!sectionContainer) return;

  const swiperElement = sectionContainer.querySelector('.solar-swiper-container');
  const tabs = sectionContainer.querySelectorAll('.solar-tab-item');
  const totalSlides = swiperElement.querySelectorAll('.swiper-wrapper > .solar-slide').length;
  if (totalSlides === 0) return;
  
  const initialMiddleSlide = Math.floor(totalSlides / 2);

  const solarSwiper = new Swiper(swiperElement, {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    loopedSlides: totalSlides,
    // FIX: with heavy negative spaceBetween (overlapping curve), Swiper's
    // auto-estimated loop padding can fall short on one side, so the 2nd
    // neighbor slide isn't rendered there at all. Force generous padding
    // on both sides so 2 slides are always available left and right.
    loopAdditionalSlides: totalSlides,
    initialSlide: initialMiddleSlide,
    grabCursor: true,
    speed: 650,
    watchSlidesProgress: true, 
    
    spaceBetween: -220, 
    breakpoints: {
      320: { spaceBetween: 12 },
      480: { spaceBetween: -30 },
      768: { spaceBetween: -140 },
      1024: { spaceBetween: -220 }
    },
    on: {
      init: function() {
        // FIX: loopAdditionalSlides (added for the curve-visibility fix)
        // changes how Swiper resolves "initialSlide" in loop mode, so it was
        // landing one slide off from the true middle. Force-correct here:
        // speed 0 (instant, no animation) and runCallbacks=false (so this
        // doesn't fire slideChange and re-trigger the tab auto-scroll).
        if (this.realIndex !== initialMiddleSlide) {
          this.slideToLoop(initialMiddleSlide, 0, false);
        }
        applySymmetricalCurve(this);
        // don't auto-scroll the tab bar on initial load — that was
        // shoving "Everyday Essentials" (tab 1) off-screen before the user
        // did anything. Just highlight the correct middle tab on init.
        syncTabs(initialMiddleSlide, false);
      },
      setTranslate: function() {
        applySymmetricalCurve(this);
      },
      slideChange: function () {
        syncTabs(this.realIndex);
      }
    }
  });

  function syncTabs(activeIndex, shouldScroll = true) {
    tabs.forEach(tab => {
      if (parseInt(tab.getAttribute('data-target')) === activeIndex) {
        tab.classList.add('is-active');
        // Smoothly auto-centers the active text label item in mobile horizontal row view
        if (shouldScroll) {
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      } else {
        tab.classList.remove('is-active');
      }
    });
  }

  function applySymmetricalCurve(swiper) {
    const slides = swiper.slides;
    // SMOOTHNESS FIX: detect if user is actively dragging vs swiper is snapping
    const isDragging = swiper.animating === false && swiper.touching;
    const transitionDuration = isDragging ? '0ms' : '650ms';

    for (let i = 0; i < slides.length; i++) {
      const slide = slides[i];
      const progress = slide.progress; 
      const absProgress = Math.abs(progress);

      // Deep perspective 3D variables
      const scale = 1.05 - (absProgress * 0.18);
      const blur = Math.min(absProgress * 5.0, 12);     
      const opacity = Math.max(1.0 - (absProgress * 0.45), 0.2);
      const translateY = (absProgress * 30) - 10;
      const translateZ = 150 - (absProgress * 180);
      
      const translateX = progress * -55;
      const rotateY = progress * -18;

      // Absolute layer stack layout indexing overrides
      const zIndex = Math.round(100 - absProgress * 20);

      // SMOOTHNESS FIX: apply transition per-slide so snapping animates smoothly
      slide.style.transitionDuration = transitionDuration;
      slide.style.transitionTimingFunction = 'cubic-bezier(0.25, 1, 0.35, 1)';
      slide.style.transitionProperty = 'transform, opacity, filter';

      slide.style.transform = `translate3d(${translateX}px, ${translateY}px, ${translateZ}px) scale(${scale}) rotateY(${rotateY}deg)`;
      slide.style.opacity = opacity;
      slide.style.filter = `blur(${blur}px)`;
      slide.style.zIndex = zIndex;
    }
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const targetIndex = parseInt(this.getAttribute('data-target'));
      // FIX: use slideToLoop() instead of manually searching slides by data-index.
      // With loop:true, Swiper clones slides and re-uses the same data-index on
      // the clones, so findIndex() could match a clone and jump to the wrong
      // physical slide/collection. slideToLoop() takes the real (non-cloned)
      // index and resolves the correct loop position internally.
      solarSwiper.slideToLoop(targetIndex);
    });
  });
}